import { ControlObject, NodeTypes } from '../../onboarding/onboarding-types';

export const isSelectionChanged = (
  initialState: ControlObject,
  currState: ControlObject,
) => {
  if (!initialState || !currState) {
    return false;
  }
  return Object.keys(initialState).some(
    nodeId =>
      initialState[nodeId].nodeType !== NodeTypes.Node &&
      initialState[nodeId].selected !== currState[nodeId]?.selected,
  );
};
